<div class="error-container" *ngIf="!!error && !!error.content" [class.full-width]="isFullWidth">
    <div class="ui red segment segment">
        <i class="red icon {{ error.icon }}"></i>
        <div class="error-content">
            <p>
                <span class="error-title">{{ error.title }}</span>
                {{ error.content }}
                <!-- TODO: Create a pipe e.g. linkify pipe, to sanitize html -->
                <span class="error-cta" [innerHtml]="error.cta"></span>
            </p>
            <div class="error-conflicts" *ngIf="error.meta?.meetingConflicts?.length">
                <span>Your Conflicts:</span>
                <ul>
                    <li *ngFor="let meeting of error.meta.meetingConflicts">
                        {{ meeting.dateStart | momentDate: 'MMM Do, h:mma' }} -
                        {{ meeting.dateEnd | momentDate: 'h:mma' }}: {{ meeting.description }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
